import { Injectable } from '@angular/core';
import {
  ConsentFormTemplateApi,
  FormTemplateTypes,
  FormTemplateUsage,
  Page,
} from '@models';
import {
  ConsentFormReq,
  ConsentTemplatesService,
  CreateConsentFormReq,
} from '@services';
import { delay, filter, map, Observable, of } from 'rxjs';

export let MOCK_DATA_CONENT_FORM_TEMPLATE: ConsentFormTemplateApi[] = [
  {
    id: '1',
    name: 'General_2026',
    consentAgreementHtml: '<p>General consent agreement</p>',
    isDefault: true,
    isDeleted: false,
    version: 1,
    language: 'en',
    type: FormTemplateTypes.ConsentForm,
    appointmentType: 'Consultation',
    appointmentTypeIds: [],
    lastUpdatedUtc: new Date().toISOString(),
    usage: FormTemplateUsage.Appointment,
  },
  {
    id: 'membership-default',
    name: 'Default membership agreement',
    consentAgreementHtml: '<p>Default membership agreement</p>',
    isDefault: true,
    isDeleted: false,
    version: 1,
    language: 'en',
    type: FormTemplateTypes.ConsentForm,
    appointmentType: null,
    appointmentTypeIds: [],
    lastUpdatedUtc: new Date().toISOString(),
    usage: FormTemplateUsage.Membership,
  },
];

@Injectable({
  providedIn: 'root',
})
export class ConsentTemplatesMockService implements ConsentTemplatesService {
  params = {
    page: 1,
    pageSize: 10,
  };

  getFormTemplates(params: {
    page: number;
    pageSize: number;
    name?: string;
    orderBy?: string;
    desc?: boolean;
    usage?: FormTemplateUsage;
  }): Observable<Page<ConsentFormTemplateApi>> {
    const data = MOCK_DATA_CONENT_FORM_TEMPLATE.filter(t =>
      params.usage ? t.usage === params.usage : true
    );

    const start = (params.page - 1) * params.pageSize;
    const items = data.slice(start, start + params.pageSize);

    return of({
      items,
      totalItems: data.length,
      pageNumber: params.page,
      pageSize: params.pageSize,
      totalPages: Math.ceil(data.length / params.pageSize),
    }).pipe(delay(500));
  }

  getFormTemplate(
    id: string,
    lang: 'en' | 'es' = 'en'
  ): Observable<ConsentFormTemplateApi> {
    return this.getFormTemplates(this.params).pipe(
      map(templates =>
        templates.items.find(t => t.id === id && (t.language ?? 'en') === lang)
      ),
      filter((t): t is ConsentFormTemplateApi => !!t)
    );
  }

  getFormTemplateNameById(id: string): Observable<string> {
    return this.getFormTemplate(id).pipe(map(t => t.name));
  }

  createTemplate(
    body: CreateConsentFormReq
  ): Observable<ConsentFormTemplateApi> {
    return of<ConsentFormTemplateApi>({
      id: '21',
      ...body,
      appointmentTypeIds: body.appointmentTypeIds ?? [],
      type: FormTemplateTypes.ConsentForm,
      appointmentType: '',
      version: 1,
      isDefault: false,
      isDeleted: false,
      lastUpdatedUtc: new Date().toISOString(),
      usage: FormTemplateUsage.Appointment,
    });
  }

  updateTemplate(
    id: string,
    body: ConsentFormReq
  ): Observable<ConsentFormTemplateApi> {
    return of({
      id,
      ...body,
      appointmentType: '',
      type: FormTemplateTypes.ConsentForm,
      version: 1,
      isDefault: false,
      isDeleted: false,
      appointmentTypeIds: [],
      lastUpdatedUtc: new Date().toISOString(),
      usage: FormTemplateUsage.Appointment,
    });
  }

  deleteTemplate(id: string): Observable<unknown> {
    MOCK_DATA_CONENT_FORM_TEMPLATE = MOCK_DATA_CONENT_FORM_TEMPLATE.filter(
      t => t.id !== id
    );
    return of();
  }
}
